import { cva, type VariantProps } from 'class-variance-authority';

export const statStylesVariants = cva('', {
  variants: {
    style: {
      'big-number': 'flex flex-col justify-start items-start gap-sm',
      'bars-vertical': 'inline-flex justify-start items-end gap-xs h-full',
      'bars-horizontal': 'flex flex-col justify-start items-start gap-xs',
    },
  },
  defaultVariants: {
    style: 'big-number',
  },
});

export type StatStylesVariantProps = VariantProps<typeof statStylesVariants>;
